module.exports = __webpack_public_path__ + "static/media/32-8.13105733.mp3";